"use client"

import { useRouter } from "next/navigation"
import { useState } from "react"
import { ProductListQuery, formatQuery } from "src/components/(landing)/common/query"
import { getLocalizedSortOptions } from "src/components/(landing)/common/sortOptions"
import { SortValue } from "src/components/(landing)/common/types"
import { NativeSelect } from "src/components/common/NativeSelect"
import { A } from "src/components/unstyled/A"
import { localizeText } from "src/localization/utils"

export type SortOptionsProps = {
  parentPath: string
  query: ProductListQuery
}

export const SortOptions = ({ parentPath, query: oldQuery }: SortOptionsProps) => {
  const router = useRouter()
  const [loading, setLoading] = useState(false)

  const sortOptions = getLocalizedSortOptions()
  const T = localizeText(text)

  return (
    <div className="relative">
      <NativeSelect
        placeholder={T.sortBy}
        loading={loading}
        value={oldQuery.sortBy}
        onChange={(event) => {
          const value = event.target.value
          const newQuery = { ...oldQuery, sortBy: value as SortValue, page: 1 }
          const newQueryString = formatQuery(newQuery)
          const href = parentPath + (newQueryString ? `/${newQueryString}` : "")

          setLoading(true)
          router.push(href)
          router.prefetch(href)
        }}
      >
        {sortOptions.map(({ value, label }, index) => (
          <option key={index} value={value}>
            {T.sortBy}: {label}
          </option>
        ))}
      </NativeSelect>

      {/* Prefetch links: */}
      {sortOptions.map(({ value, label }, index) => {
        const newQuery = { ...oldQuery, sortBy: value as SortValue, page: 1 }
        const newQueryString = formatQuery(newQuery)
        const href = parentPath + (newQueryString ? `/${newQueryString}` : "")

        return (
          <A href={href} key={index} className="invisible absolute top-0 left-0">
            {T.sortBy}: {label}
          </A>
        )
      })}
    </div>
  )
}

const de = {
  sortBy: "Sortieren nach",
}

const en: typeof de = {
  sortBy: "Sort by",
}

const text = { de, en }
